import BookCard from './cards/BookCard'
import PaperCard from './cards/PaperCard'
import CourseCard from './cards/CourseCard'
import VideoCard from './cards/VideoCard'
import PodcastCard from './cards/PodcastCard'
import PolicyCard from './cards/PolicyCard'
import CodeNotebookCard from './cards/CodeNotebookCard'

import BookList from './lists/BookList'
import PaperList from './lists/PaperList'
import CourseList from './lists/CourseList'
import VideoList from './lists/VideoList'
import PodcastList from './lists/PodcastList'
import PolicyList from './lists/PolicyList'
import CodeNotebookList from './lists/CodeNotebookList'

// Resource `type` (the serializer's model class name) -> its Card and List components.
export const RESOURCE_TYPE_COMPONENTS = {
    Book: { Card: BookCard, List: BookList },
    Paper: { Card: PaperCard, List: PaperList },
    Course: { Card: CourseCard, List: CourseList },
    Video: { Card: VideoCard, List: VideoList },
    Podcast: { Card: PodcastCard, List: PodcastList },
    Policy: { Card: PolicyCard, List: PolicyList },
    CodeNotebook: { Card: CodeNotebookCard, List: CodeNotebookList },
}
